import React from 'react';

import Button from '@/core/components/Button';
import DonationDeleteModal from '@/core/components/DonationDeleteModal';
import useDisclosure from '@/core/hooks/useDisclosure';
import type { FinishAction } from '@/core/lib/new-architecture/domain/donation.domain';
import { useTranslationContext } from '@/core/lib/translation/translation.context';

interface FinishActionComponentProps {
  action: FinishAction;
}

const FinishActionComponent: React.FC<FinishActionComponentProps> = ({ action }) => {
  const { t } = useTranslationContext(['common']);

  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      {action.isDisabled ? null : (
        <Button onClick={onOpen} variant="secondary" size="large" iconLeft="check">
          {t(action.text, { ns: 'common' })}
        </Button>
      )}
      <DonationDeleteModal isOpen={isOpen} closeModal={onClose} donationId={action.donationId} />
    </>
  );
};

export default FinishActionComponent;
